<template>
  <div id="index">
        <dv-full-screen-container class="dbg">
    <div class="dbg">
            <dv-loading v-if="loading">Loading...</dv-loading>
      <div v-else class="host-body">
        <router-link to='/'>
          <div class="d-flex jc-center">
            <img src="../assets/top.png" width="100%"/>
          </div>
        </router-link>
        <!-- 第二行 -->
        <div class="d-flex jc-between px-2" style="position: relative;margin-top: -1rem;z-index: -1">
          <div class="d-flex" style="width: 40%">
          </div>
          <div style="width: 40%" class="d-flex">
            <div class="react-left  mr-3">
              <!--              <span class="text fw-b">vue-big-screen</span>-->
            </div>
            <!--            <div-->
            <!--              class="react-left mr-4"-->
            <!--              style="width: 6.25rem; text-align: right;color:#fff"-->
            <!--            >-->
            <!--              <span class="react-after"></span>-->
            <!--              <span class="text">{{dateYear}} {{dateWeek}} {{dateDay}}</span>-->
            <!--            </div>-->
          </div>
        </div>


        <div class="body-box">
          <!-- 第一列数据 -->
          <div class="content-box">
            <div class="column3" style="margin-top: 0.5rem;padding-left: 0.8rem">
<!--              <div class="d-flex-center pos">-->
<!--&lt;!&ndash;                <router-link to='/technology'><h2 class="titleMax">创新主体</h2></router-link>&ndash;&gt;-->
<!--&lt;!&ndash;                <router-link to='/carrierTech'><h2 class="titleMax">科创平台</h2></router-link>&ndash;&gt;-->
<!--              </div>-->
              <div class="bg-border" style="height:40vh;">
                <div class="bg-border-inner" >
                  <div class="d-flex pt-2 text-line">
       <span class="icon-cube" style="color:#5cd9e8;font-size: 0.3rem;width: 100%">
           <span class="fs-xl text mx-2" style="font-size: 0.3rem;color: #5cd9e8">科技创新主体统计</span>
        </span>
                  </div>

                  <div class="open-box">
                    <div class="item" v-for="(item,pi) in Num" :key="pi">
                      <i class="iconfont" :class="icon1[pi]" :style="{'color':color[0],'border-color':color[0]}" >
                      </i>
                      <div class="d-table">
                        <span class="num">{{item}}</span> &nbsp;家
                        <p style="font-size: 16px;text-align: center" :style="{'color':color[0]}">{{pi}}</p>
                      </div>
                    </div>
                  </div>

                </div>
              </div>
              <div class="bg-border" style="height: 50vh">
                <div class="bg-border-inner" >
                  <div class="d-flex pt-2 text-line">
       <span class="icon-cube" style="color:#E6A23C;font-size: 0.3rem;width: 100%">
           <span class="fs-xl text mx-2" style="font-size: 0.3rem;color: #E6A23C">科技创新平台统计</span>
        </span>
                  </div>

                  <div class="open-box">
                    <div class="item" v-for="(item,pi) in Rum" :key="pi">
                      <i class="iconfont" :class="icon2[pi]" :style="{'color':color[1],'border-color':color[1]}"></i>
                      <div class="d-table">
                        <span class="num">{{item}}</span> &nbsp;家
                        <p style="font-size: 16px;text-align: center" :style="{'color':color[1]}">{{pi}}</p>
                      </div>
                    </div>
                  </div>
<!--                  <TransferNum/>-->
                </div>
              </div>
<!--              <div class="bg-border" style="height:30vh">-->
<!--                <div class="bg-border-inner" >-->
<!--                  <Dynamics/>-->
<!--                </div>-->
<!--              </div>-->
            </div>
            <!-- 第二列数据 -->
            <div class="column4">
              <div style="height: 90vh">
                <div class="c-box">

                    <router-link to='/technology'>
                      <div class="item" style="margin-left: 0.2rem;animation: bounce-down 1.8s linear infinite;">
                        <img src="../assets/01.png"/>
                        <p>科创主体</p>
                      </div>
                    </router-link>
                  <router-link to='/carrierTech'>
                    <div class="item" style="margin-top: 3rem;margin-right: 1.5rem;animation: bounce-down 1.7s linear infinite;">
                      <img src="../assets/02.png"/>
                      <p>科创平台</p>
                    </div>
                  </router-link>

                     <router-link to='/achievements'>
                       <div class="item" style="margin-top: 3rem;margin-left: 1.5rem;animation: bounce-down 1.8s linear infinite;">
                         <img src="../assets/04.png"/>
                         <p>科创成效</p>
                       </div>
                     </router-link>
                  <router-link to='/techTalents'>
                     <div class="item" style="animation: bounce-down 1.7s linear infinite;">
                       <img src="../assets/03.png"/>
                       <p>科创人才</p>
                     </div>
                   </router-link>


                </div>
              </div>
              <!--              <div class="bg-border" style="height:28vh">-->
              <!--                <div class="bg-border-inner" >-->
              <!--                  <TotalAmount/>-->
              <!--                </div>-->
              <!--              </div>-->
            </div>
            <!-- 第三列数据 -->
            <div class="column3" style="margin-top: 0.5rem;padding-left: 1rem">
<!--              <div class="d-flex-center pos">-->
<!--&lt;!&ndash;                <router-link to='/technology'><h2 class="titleMax ">科创人才</h2></router-link>&ndash;&gt;-->
<!--&lt;!&ndash;                <router-link to='/achievements'><h2 class="titleMax ">科创成效</h2></router-link>&ndash;&gt;-->
<!--              </div>-->
              <div class="bg-border" style="height:40vh">
                <div class="bg-border-inner" >
                  <div class="d-flex pt-2 text-line">
       <span class="icon-cube" style="color:rgb(255, 219, 92);font-size: 0.3rem;width: 100%">
           <span class="fs-xl text mx-2" style="font-size: 0.3rem;color:rgb(255, 219, 92)">科技创新人才统计</span>
        </span>
                  </div>

                  <div class="open-box">
                    <div class="item" v-for="(item,pi) in Tum" :key="pi">
                      <i class="iconfont" :class="icon3[pi]" :style="{'color':color[2],'border-color':color[2]}"></i>
                      <div class="d-table">
                        <span class="num">{{item}}</span> &nbsp;{{ pi=='科研人员'?'人':pi=='专家团队'?'个':''}}
                        <p style="font-size: 16px;text-align: center" :style="{'color':color[2]}">{{pi}}</p>
                      </div>
                    </div>
                  </div>
<!--                  <TotalAmount/>-->
                </div>
              </div>
              <div class="bg-border" style="height: 50vh">
                <div class="bg-border-inner" >
                  <div class="d-flex pt-2 text-line">
       <span class="icon-cube" style="color:#e7bcf3;font-size: 0.3rem;width: 100%">
           <span class="fs-xl text mx-2" style="font-size: 0.3rem;color: #e7bcf3">科技创新成效统计</span>
        </span>
                  </div>

                  <div class="open-box">
                    <div class="item" style="width: 100%" v-for="(item,pi) in Pum" :key="pi">
                      <i class="iconfont" :class="icon4[pi]" :style="{'color':color[3],'border-color':color[3]}"></i>
                      <div class="d-table">
                        <span class="num">{{item}}</span> &nbsp;{{ (pi=='科技成果'?'项':pi=='科技项目')?'项':pi=='授权专利'?'项':'万元'}}
                        <p style="font-size: 16px;text-align: center" :style="{'color':color[3]}">{{pi}}</p>
                      </div>
                    </div>
                  </div>
<!--                  <MallAmount/>-->
                </div>
              </div>
<!--              <div class="bg-border" style="height: 30vh">-->
<!--                <div class="bg-border-inner" >-->

<!--                  <TransferAmount/>-->
<!--                </div>-->
<!--              </div>-->
            </div>
          </div>
<!--          <div style="bottom:0;width: 100%; text-align: center;color: #fff;background: linear-gradient(99deg, rgba(6, 20, 111, 0.43) 0%, #0B209D 50%, rgba(6, 20, 111, 0.43) 100%);;line-height: 45px;font-size: 16px">-->
<!--            Copyright © 2019 铜梁科创服务平台 版权所有&emsp;&emsp;-->
<!--            <a href="https://beian.miit.gov.cn/" target="_blank" style="color: #fff"-->
<!--            >渝ICP备09050127号-36</a-->
<!--            >-->
<!--          </div>-->
        </div>
      </div>
    </div>
        </dv-full-screen-container>
  </div>
</template>

<script>
import sciApi from '@/api/index.js'
import { formatTime } from '../utils/index.js'
// import Map from "@/components/technology/map";
// import Dynamics from "@/components/technology/dynamics";
// import MallAmount from "@/components/technology/mallAmount";
// import TotalAmount from "@/components/technology/totalAmount";
// import MallNum from "@/components/technology/mallNum";
// import TransferAmount from "@/components/technology/transferAmount";
// import TransferNum from "@/components/technology/transferNum";
export default {
  data () {
    return {
      path:'',
      activeName: 'first',
      ach:{},
      icon1:{
        // '科技型企业':'iconkejiqiye',
        '科技型企业入库':'icon01_dairuzhu',
        '高新技术企业':'iconjigouxinxi',
        '高新技术企业培育库':'iconqiyeyuanquwuye'
      },
      icon2:{
        '科技研发类平台':'iconyanfaguanli-xuqiuguanli',
        '科技孵化类平台':'iconzhishichanquan',
        '成果转化类平台':'iconchengguozhuanhuafuwu',
        // '新型研发机构':'iconjigouxinxi',
        // '重点实验室':'iconyanfaguanli-xuqiuguanli',
        '科学普及类平台':'iconzhengcejiedu-'
      },
      icon3:{
        // '技术人才':'iconzhaozhuanjia',
        '科研人员':'iconzhaozhuanjia',
        // '科技特派员':'iconrencai',
        '专家团队':'iconzujiantuandui',

      },
      icon4:{
        '技术合同登记':'iconzhengcefagui2',
        '研发费用投入':'iconcaiwu',
        // '科技服务产值':'iconguoyouqiyecaiwu',
        // '科技成果':'iconchengguozhuanhuafuwu',
        '科技项目':'iconyanfaguanli-xitongshezhi',
        '授权专利':'iconchengguozhitongche'
      },
      Num:{
        '科技型企业入库':0,
        // '科技型企业':0,
        '高新技术企业':0,
        '高新技术企业培育库':0
      },
      Tum:{
        // '技术人才':0,
        '科研人员':0,
        // '科技特派员':0,
        '专家团队':0,
        // '技术经纪人':0
      },
      Rum:{
        '科技研发类平台':0,
        '科技孵化类平台':0,
        '成果转化类平台':0,
        '科学普及类平台':0,
        // '重点实验室':0,
        // '技术创新中心':0
      },
      Pum:{
        '技术合同登记':0,
        '研发费用投入':0,
        //'知识产权':0,
        //'科技项目':0,
        // '授权专利': 0,

      },
      color:[
      '#5cd9e8',
        // 'rgb(250, 124, 54)',
          '#E6A23C',
        'rgb(255, 219, 92)',
        '#e7bcf3'
      ],
      loading: true,
      dateDay: null,
      dateYear: null,
      dateWeek: null,
      weekday: ["周日", "周一", "周二", "周三", "周四", "周五", "周六"],
    };
  },
  components: {
    // TotalAmount,//平台交易总金额
    // TransferAmount,//成果交易金额
    // TransferNum,//成果交易笔数
    // // Map,//地图
    // Dynamics,//交易动态
    // MallAmount,//易智商城交易金额
    // MallNum,//易智商城交易笔数
  },
  watch:{
    typeList:{
      handler() {
        this.region=this.typeList.name
        this.$store.commit('setregion',this.region)
      }
    }
  },
  computed:{
    typeList(){
      return this.$store.state.typeList
    }

  },
  mounted () {
    this.path=this.$route.name
    // this.timeFn();
    this.init();
    this.cancelLoading();
  },
  methods: {
    async init(){
      const that = this;
      await sciApi.selectSciList().then((data)=> {
        // data 就是接口返回值
        this.ach = data || {}
        // that.Num['科技型企业'] = parseInt(this.ach[0].customNum);
        that.Num['科技型企业入库'] = parseInt(this.ach.keQiHomeCount.num);
        // that.Num['科技型企业入库'] = 1141;
        that.Num['高新技术企业'] = parseInt(this.ach.gaoQiHomeCount.num);
        // that.Num['高新技术企业'] = 175;
        that.Num['高新技术企业培育库'] = parseInt(this.ach.gaoQiPeiYuHomeCount.num);

        // that.Tum['技术人才'] = parseInt(this.ach.technologicalTalent.num);
        // that.Tum['科研人员'] = 4883;
        that.Tum['科研人员'] = parseInt(this.ach.specialCommissionerCount.num);
        that.Tum['专家团队'] = parseInt(this.ach.rencaiTeamHomeCount.num || 0);


        //that.Rum['科技研发类平台'] = parseInt(this.ach.platformHomeCount[0].num);
        that.Rum['科技研发类平台'] = parseInt(this.ach.platformHomeCount[0].num);
        that.Rum['科技孵化类平台'] = parseInt(this.ach.platformHomeCount[1].num);
        that.Rum['成果转化类平台'] = parseInt(this.ach.platformHomeCount[2].num);
        that.Rum['科学普及类平台'] = parseInt(this.ach.platformHomeCount[3].num);
        // that.Rum['新型研发机构'] = parseInt(this.ach[16].customNum);
        // that.Rum['技术创新中心'] = parseInt(this.ach[15].customNum);

        that.Pum['技术合同登记'] = parseInt(this.ach.rencaiCountAndTechDeal[0].num);
        // that.Pum['技术合同登记'] = 32236;

        that.Pum['研发费用投入'] = parseInt(this.ach.rencaiCountAndTechDeal[1].num);
        // that.Pum['研发费用投入'] = 113100;


        // that.Pum['科技服务产值'] = parseInt(this.ach[11].customNum);
        // that.Pum['科技成果'] = parseInt(this.ach[12].customNum);
        //that.Pum['知识产权'] = parseInt(this.ach.patentHomeCount.num);
        // that.Pum['授权专利'] = 647;


        //that.Pum['科技项目'] = parseInt(this.ach.projectListHome.num);

      })
    },
    timeFn () {
      setInterval(() => {
        this.dateDay = formatTime(new Date(), 'HH: mm: ss');
        this.dateYear = formatTime(new Date(), 'yyyy-MM-dd');
        this.dateWeek = this.weekday[new Date().getDay()];
      }, 1000)
    },
    cancelLoading () {
      setTimeout(() => {
        this.loading = false;
      }, 200);
    }
  }
};
</script>

<style lang="scss">
@import '../assets/scss/index.scss';
.btnList{
  padding: 0.4rem;
  width: 100%;
  margin: 0!important;
}
.mx-2{
  margin-left: 0.2rem!important;
}
.btnList .grid-content{
  //float: left;
  //width: 50%;
  height: 1.6rem;
  flex: 1;
  text-align: center;
  font-size: 20px;
  background: #142957;
  margin-bottom: 20px;
  padding-top: 0.3rem;
  border-radius: 0 0.2rem 0 0;
  color:#4c9bfd
}
.btnList .grid-content.active{
  background:#4169E1;
  color: #fff;
}
.btnList .grid-content:hover{
  background:#4169E1;
  color: #fff;
}
.grid-content i{
  width: 100%;
  margin-bottom: 10px;
  font-size: 48px!important;
}
.btnList .grid-content:nth-child(11){
  margin-bottom: 0;
}
.titleMax{
  width: 200px;
  height: 60px;
  font-size: 22px;
  font-weight: normal;
  //border: 1px solid rgb(92, 217, 232);
  background: url(../assets/btn.png)no-repeat center;
  //background-size: cover;
  line-height: 60px;
  padding: 0 0.4rem;
  font-weight: bold;
  //margin-top: 0.2rem;
  margin-bottom: 0.8rem;
  color:#fff;
  text-align: center;
  font-weight: normal;
  cursor: pointer;
}
.titleMax:hover{
  background: url(../assets/hover.png)no-repeat center;
  color: rgb(92, 217, 232);


}
.active{
  background: url(../assets/hover.png)no-repeat center;
  color: rgb(92, 217, 232);
  font-weight: bold;
}
.mt-2{
  margin-top: -15px;
}
.pos{
  position: relative;
  align-items: center;
  //top: -40px;
  width: 100%;
  margin-top: -0.5rem;
  //margin-bottom: 0.2rem;
  //border-bottom: 1px solid #4c9bfd;
}
.pos h2:first-child{
  margin-right: 0.4rem;
}
.d-flex-center{
  display: flex;
  justify-content: center;
}
.titleMax i{
  font-size: 40px;
  line-height: 40px;
  margin-right: 10px;
  vertical-align: middle;
}
.open-box{
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: center;
  margin-top: 0.4rem;
}
.d-table{
  display: inline-table;
  font-size: 16px;
  color: #fff;
  //text-align: center;
}
.d-table p{
  text-align: left!important;
}
.open-box .item{
  width: 50%;
  margin-top: 0.5rem;
  display: flex;
  align-items: center;
}
.open-box .item i{
  border: 2px solid rgb(92, 217, 232);
  font-size: 30px;
  width: 60px;
  height: 60px;
  border-radius: 50%;
  margin-right: 0.2rem;
  text-align: center;
  line-height: 60px;
}
.open-box .item span{
  font-size: 36px;
 color: #fff;
  font-weight: bold;
  line-height: 42px;
  text-align: left;

}
.c-box{
  top:45%;
  left:50%;
  position: fixed;
  display: flex;
  justify-content: space-around;
  width: 740px;
  /*background: #fff;*/
  /*padding: 20px 15px;*/
  z-index: 999;
  transform: translate(-50%, -50%);
  -webkit-transform: translate(-50%, -50%);
  -o-transform: translate(-50%, -50%);
  -moz-transform: translate(-50%, -50%);
  -ms-transform: translate(-50%, -50%);
  /*min-height: calc(100vh - 600px);*/

}
@keyframes bounce-down{
  25%{
    -webkit-transform: translateY(-4px);
  }
  50%,100%{
    -webkit-transform: translateY(0);
  }
  75%{
    -webkit-transform: translateY(4px);
  }
}
.c-box .item{
  display: block;
  position: relative;

}
//.c-box a:nth-child(1) .item:hover .bg-border:first-child .open-box{
//    background: rgb(92, 217, 232)
//}
.c-box .item p{
  color:#fff;
  font-size: 24px;
  font-weight: bold;
  //padding: 0.2rem 0;
  line-height: 50px;
}
.c-box .item:after{
  content: '';
  position: absolute;
  left:46%;
  height: 100px;
  width: 3px;
  background-image: linear-gradient(#28f7ff,transparent);
}
.text-line{
  position: relative;
}
.text-line:after{
  content: '';
  position: absolute;
  left:0;
  top:50px;
  height: 2px;
  width:100%;
  background-image: linear-gradient(to right,#28f7ff,transparent);
}
</style>
